import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function SiteHeader() {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);

  const links = [
    { href: "/#fenomeno", label: t.nav.fenomeno },
    { href: "/#coste", label: t.nav.coste },
    { href: "/#solucion", label: t.nav.solucion },
    { href: "/#privacidad", label: t.nav.privacidad },
    { href: "/#calcolatore", label: t.nav.calculadora },
  ];

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-cream/10 bg-forest-950/85 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
        <a href="/#top" className="flex items-baseline gap-3" data-testid="header-logo">
          <span className="font-body text-sm font-bold tracking-[0.2em] text-cream">WASTEDATA</span>
          <span className="hidden font-body text-[10px] uppercase tracking-[0.3em] text-cream/50 sm:inline">
            Infinicity
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" data-testid="header-nav">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("/#", "")}`}
              className="text-[13px] font-medium text-cream/70 transition-colors hover:text-cream"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/documentos"
            data-testid="nav-link-documentos"
            className="text-[13px] font-medium text-cream/70 transition-colors hover:text-cream"
          >
            {t.nav.documentos}
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center border border-cream/20 font-mono text-[11px]" data-testid="lang-toggle">
            <button
              type="button"
              data-testid="lang-es"
              onClick={() => setLang("es")}
              className={`px-2.5 py-1.5 transition-colors ${lang === "es" ? "bg-ember font-bold text-white" : "text-cream/50 hover:text-cream"}`}
            >
              ES
            </button>
            <button
              type="button"
              data-testid="lang-it"
              onClick={() => setLang("it")}
              className={`px-2.5 py-1.5 transition-colors ${lang === "it" ? "bg-ember font-bold text-white" : "text-cream/50 hover:text-cream"}`}
            >
              IT
            </button>
          </div>
          <a
            href="/#contacto"
            data-testid="header-cta-demo"
            className="hidden bg-ember px-5 py-2 text-[13px] font-bold text-white transition-colors hover:bg-orange-600 sm:inline-block"
          >
            {t.nav.cta}
          </a>
          <button
            type="button"
            aria-label="Menu"
            data-testid="header-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-cream lg:hidden"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-cream/10 bg-forest-950/95 px-5 py-4 lg:hidden" data-testid="header-mobile-nav">
          <div className="flex flex-col gap-4">
            {links.map((link) => (
              <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="text-sm font-medium text-cream/70 hover:text-cream">
                {link.label}
              </a>
            ))}
            <Link to="/documentos" onClick={() => setOpen(false)} className="text-sm font-medium text-cream/70 hover:text-cream">
              {t.nav.documentos}
            </Link>
            <a
              href="/#contacto"
              onClick={() => setOpen(false)}
              className="mt-2 bg-ember px-5 py-2.5 text-center text-sm font-bold text-white"
            >
              {t.nav.cta}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
